<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              {{ $t('settings.title') }}
            </h1>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="4">
            <div class="center-horizontal">
              <!-- Profile -->
              <safe-router-link to="/user-profile" class="nav__menu-item">
                <div class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.profile"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('personalArea.profile') }}</div>
                </div>
              </safe-router-link>

              <!-- Users -->
              <safe-router-link to="/user/list">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.user"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('settings.users') }}</div>
                </div>
              </safe-router-link>

              <!-- Corporate Groups -->
              <safe-router-link to="/corporate-groups" class="nav__menu-item">
                <div v-has-feature="'CorporateGroupsManagement'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.briefcase"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.corporateGroups.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Groups -->
              <safe-router-link to="/group/list" class="nav__menu-item">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.group"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('settings.groups') }}</div>
                </div>
              </safe-router-link>

              <!-- User Sensor Time -->
              <safe-router-link to="/user-sensor" class="nav__menu-item">
                <div v-has-feature="'UserSensorTime'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.sensor"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.settings.userSensorTime') }}</div>
                </div>
              </safe-router-link>

              <!-- Permissions -->
              <safe-router-link to="/permission-assignment" class="nav__menu-item">
                <div v-has-feature="'PermissionAssignment'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.permission"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('settings.permission') }}</div>
                </div>
              </safe-router-link>

              <!-- Supervisors -->
              <safe-router-link to="/supervisors" class="nav__menu-item">
                <div class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.glass"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.settings.supervisors') }}</div>
                </div>
              </safe-router-link>

              <!-- Manage my Accesses -->
              <safe-router-link to="/manage-my-access" class="nav__menu-item">
                <div class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.lock"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.manageAccess.title') }}</div>
                </div>
              </safe-router-link>

              <!-- My patients -->
              <safe-router-link to="/patients" class="nav__menu-item">
                <div v-has-feature="'Patients'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.patient"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.patient.title') }}</div>
                </div>
              </safe-router-link>

              <!-- My patients -->
              <safe-router-link to="/assign-patients" class="nav__menu-item">
                <div v-has-feature="'AssignPatients'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.assignNutritionist"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.assignPatients.title') }}</div>
                </div>
              </safe-router-link>

              <!-- notification messages -->
              <safe-router-link to="/notification-messages" class="nav__menu-item">
                <div v-has-feature="'NotificationMessages'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.notifications"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.notificationMessages.title') }}</div>
                </div>
              </safe-router-link>

            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faUser,
  faUsers,
  faUserCog,
  faUserClock,
  faUserShield,
  faUserLock,
  faFolder,
  faBallotCheck,
  faBell,
  faBriefcase
} from '@fortawesome/pro-light-svg-icons';
import {
  faSearch
} from '@fortawesome/pro-regular-svg-icons';
import SafeRouterLink from '@/components/shared/SafeRouterLink';

export default {
  name: 'UsersGroupsAndPermissions',
  components: {
    SafeRouterLink,
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon
  },
  data () {
    return {
      icon: {
        user: faUser,
        group: faUsers,
        profile: faUserCog,
        sensor: faUserClock,
        permission: faUserShield,
        glass: faSearch,
        lock: faUserLock,
        patient: faFolder,
        assignNutritionist: faBallotCheck,
        notifications: faBell,
        briefcase: faBriefcase
      }
    };
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.settings'),
          link: '/settings',
          disabled: true
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables.scss";

  .buttons {
    text-align: center;
  }

  .personal-area-element {
    align-items: center;
    display: inline-block;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    font-size: 7rem;
  }

  .personal-area-element-title {
    margin-top: 0.5rem;
    font-size: 1.3rem;
    font-weight: bold;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/Settings.vue